import script from "./ProjectInvoiceDropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInvoiceDropper.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInvoiceDropper.vue?vue&type=style&index=0&id=43995930&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43995930"]])

export default __exports__